import { Col, Progress, Row, Spin, Table } from "antd";
import { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { getDashboardApi } from "mock/dashboardDemoData";

const CertificateOverview = ({ showModalState, setShowModalState }) => {

    const [certificateOverviewData, setCertificateOverviewData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [dataSource, setDataSource] = useState([]);
    const clientId = localStorage.getItem("client_id");

    useEffect(() => {
        let isMounted = true;
        
        const fetchData = async () => {
            if (isMounted) setIsLoading(true);
            try {
                const { error, result } = await getDashboardApi(`/get_certificate_details_by_client?client_id=${clientId}`);
                if (!error && isMounted) {
                    console.log('Certificate Overview API Response:', result);
                    // API returns {success, message, result}, so we need result.result
                    setCertificateOverviewData({ result: result.result });
                }
            } catch (err) {
                console.error('Error fetching certificate overview:', err);
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };
        
        if (clientId) {
            fetchData();
        } else {
            setIsLoading(false);
        }
        
        return () => {
            isMounted = false;
        };
    }, [clientId]);

    useEffect(() => {
        if (!Array.isArray(certificateOverviewData?.result) || certificateOverviewData.result.length === 0) {
            setDataSource([]);
        } else {
            let dataArray = [];
            for (
                let i = 0;
                i < certificateOverviewData.result.length;
                i++
            ) {
                dataArray.push({
                    certificate:
                        certificateOverviewData.result[i]
                            .certificate_type,
                    status:
                        certificateOverviewData.result[i].expired_count,
                    certificate_details:
                        certificateOverviewData.result[i]
                            .certificate_details,
                });
            }

            setDataSource(dataArray)
        }
    }, [certificateOverviewData])

    const showExpiredCertificate = (data) => {
        setShowModalState(prev => ({
            ...prev,
            expiredCerificateData: [...data].sort((a, b) =>
                a.name ? a.name.localeCompare(b.name) : a.expiry_date - b.expiry_date
            ),
            isExpiredCertificateModal: true,
            isShowModal: true,
        }));
    }

    const columns = [
        {
            title: "Certificate",
            dataIndex: "certificate",
            key: "certificate",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (_, data) =>
                data.certificate_details.length > 0 ? (
                    data.status == 0 ? (
                        <div className="status_main">
                            <div className="status_dot_green"></div> Up to Date
                        </div>
                    ) : (
                        <div className="status_main">
                            <div className="status_dot_red"></div>
                            {data.status} Expired
                        </div>
                    )
                ) : (
                    <div className="status_main">
                        <div className=""></div>-
                    </div>
                ),
        },
        {
            title: "",
            dataIndex: "action",
            key: "action",
            render: (_, data) => (
                <div
                    onClick={() => {
                        showExpiredCertificate(data.certificate_details);
                        setShowModalState(prev => ({
                            ...prev,
                            modalTitle: `${data.certificate} Certificates`,
                            hasNoUsername:
                                data.certificate == "WorkCover" ||
                                    data.certificate == "Labour Hire"
                                    ? true
                                    : false,
                            isIso: data.certificate == "ISO" ? true : false,
                            hasDescription:
                                data.certificate == "Public Liability" ? true : false,
                        }));
                    }}
                    style={{cursor: "pointer"}}
                >
                    <RightOutlined />
                </div>
            ),
        },
    ];

    return (
        <div className="title-container">
            <div className="mb-3">
                Certificate Overview
            </div>

            <div className="dashboard-table h-100">
                {
                    isLoading || dataSource.length == 0 ? (
                        <div style={{ height: "240px", width: "100%", color: "#666" }} className="d-flex justify-content-center align-items-center">
                            {isLoading ? <Spin /> : "No certificates to show"}
                        </div>
                    ) : (
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                        />
                    )
                }
            </div>
            {/* <Col span={8} xxl={8} md={12} sm={24} xs={24}>
                    <Box
                        title={configs.EducationAndTrainingOverview.title}
                        className="custom-box"
                    >
                        {this.props
                            .education_and_training_overview_by_group_month_data
                            .result ? (
                            <Row gutter={[15]}>
                                {this.props.education_and_training_overview_by_group_month_data.result.map(
                                    (data) => {
                                        if (data.education_type == "Monthly Education") {
                                            return (
                                                <Col span={24}>
                                                    <div className="education_training_overview_main">
                                                        <div className="percentage_box">
                                                            {data.submission_percentage}
                                                        </div>
                                                        <div className="percentage_box_2">
                                                            <div className="percentage_sign">%</div>
                                                            <div>Completed Monthly</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        }
                                    }
                                )}

                                {this.props.education_and_training_overview_by_group_month_data.result.map(
                                    (data, index) => {
                                        return (
                                            <Col span={6}>
                                                <div className="progress_main">
                                                    <div className="progress_label">
                                                        {data.education_type ==
                                                            "Tool Box Education"
                                                            ? "Toolbox"
                                                            : data.education_type ==
                                                                "Monthly Education"
                                                                ? "Monthly"
                                                                : data.education_type}
                                                    </div>
                                                    <div className="progress_bar">
                                                        <Progress
                                                            percent={Number(
                                                                (data.submission_count /
                                                                    data.total_user_count) *
                                                                100
                                                            )}
                                                            showInfo={false}
                                                        />
                                                    </div>
                                                    <div className="progress_number">
                                                        {data.education_type ==
                                                            "Monthly Education"
                                                            ? `${data.submission_count}/${data.total_user_count}`
                                                            : `${data.submission_count}`}
                                                    </div>
                                                    <div className="learn_more">
                                                        <Link
                                                            to={`/dashboard/education?month=${this.state.selectedDate.format(
                                                                "YYYY-MM"
                                                            )}&edu_type=${data.education_type}`}
                                                        >
                                                            <a>Learn more</a>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    }
                                )}
                            </Row>
                        ) : (
                            <ChartLoader />
                        )}
                    </Box>
                </Col>
                <Col span={8} xxl={8} md={12} sm={24} xs={24}>
                    <Box
                        title={
                            <div className="custom_title_main">
                                {configs.EquipmentOverview.title}
                            </div>
                        }
                        className="custom-box"
                    >
                        {this.state.equipmentDatasource.length > 0 ? (
                            <Table
                                columns={this.equipmentOverviewColumns}
                                dataSource={this.state.equipmentDatasource}
                                className="dashboard_table"
                                rowClassName={() => "no-hover-bg"}
                                pagination={false}
                                showHeader={false}
                            />
                        ) : (
                            <ChartLoader />
                        )}
                    </Box>
                </Col> */}


        </div>
    )
}

export default CertificateOverview;